<template>
  <div class="body">
    <PersonalHeader />
    <main class="main">
      <div class="caption flex al-cent">
        <div class="caption-greetings">
          <h1 class="caption-greetings__title">Добавление заметки</h1>
        </div>
        <PersoneInCaption />
      </div>
      <div class="head">
        <router-link :to="{ name: 'diaryPage' }" class="head__link">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.3326 13.3335L4.38993 14.2761L3.44727 13.3335L4.38993 12.3908L5.3326 13.3335ZM27.9993 24.0001C27.9993 24.3537 27.8588 24.6929 27.6087 24.9429C27.3587 25.193 27.0196 25.3335 26.6659 25.3335C26.3123 25.3335 25.9732 25.193 25.7231 24.9429C25.4731 24.6929 25.3326 24.3537 25.3326 24.0001H27.9993ZM11.0566 20.9428L4.38993 14.2761L6.27527 12.3908L12.9419 19.0575L11.0566 20.9428ZM4.38993 12.3908L11.0566 5.72412L12.9419 7.60945L6.27527 14.2761L4.38993 12.3908ZM5.3326 12.0001H18.6659V14.6668H5.3326V12.0001ZM27.9993 21.3335V24.0001H25.3326V21.3335H27.9993ZM18.6659 12.0001C21.1413 12.0001 23.5153 12.9835 25.2656 14.7338C27.0159 16.4841 27.9993 18.8581 27.9993 21.3335H25.3326C25.3326 19.5653 24.6302 17.8697 23.38 16.6194C22.1297 15.3692 20.434 14.6668 18.6659 14.6668V12.0001Z" fill="black" />
          </svg>
          Вернуться к заметкам
        </router-link>
      </div>
      <div class="filling ">
        <div class="note">
          <div class="field">
            <p class="field__title">Название заметки:</p>
            <label class="field-content">
              <input v-model="note.title" class="field__input" placeholder="Название заметки">
            </label>
          </div>
          <div class="field field--textarea">
            <p class="field__title">Текст заметки:</p>
              <textarea v-model="note.description" class="field__input field-content" placeholder="Введите текст заметки"></textarea>
          </div>
          <div class="grid-2">
            <div class="field">
              <p class="field__title">Дата</p>
              <label class="field-content">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 12C2 8.229 2 6.343 3.172 5.172C4.344 4.001 6.229 4 10 4H14C17.771 4 19.657 4 20.828 5.172C21.999 6.344 22 8.229 22 12V14C22 17.771 22 19.657 20.828 20.828C19.656 21.999 17.771 22 14 22H10C6.229 22 4.343 22 3.172 20.828C2.001 19.656 2 17.771 2 14V12Z" stroke="#CBCAD5" stroke-width="1.5" />
                  <path d="M7 4V2.5M17 4V2.5M2.5 9H21.5" stroke="#CBCAD5" stroke-width="1.5" stroke-linecap="round" />
                  <path d="M18 17C18 17.2652 17.8946 17.5196 17.7071 17.7071C17.5196 17.8946 17.2652 18 17 18C16.7348 18 16.4804 17.8946 16.2929 17.7071C16.1054 17.5196 16 17.2652 16 17C16 16.7348 16.1054 16.4804 16.2929 16.2929C16.4804 16.1054 16.7348 16 17 16C17.2652 16 17.5196 16.1054 17.7071 16.2929C17.8946 16.4804 18 16.7348 18 17ZM18 13C18 13.2652 17.8946 13.5196 17.7071 13.7071C17.5196 13.8946 17.2652 14 17 14C16.7348 14 16.4804 13.8946 16.2929 13.7071C16.1054 13.5196 16 13.2652 16 13C16 12.7348 16.1054 12.4804 16.2929 12.2929C16.4804 12.1054 16.7348 12 17 12C17.2652 12 17.5196 12.1054 17.7071 12.2929C17.8946 12.4804 18 12.7348 18 13ZM13 17C13 17.2652 12.8946 17.5196 12.7071 17.7071C12.5196 17.8946 12.2652 18 12 18C11.7348 18 11.4804 17.8946 11.2929 17.7071C11.1054 17.5196 11 17.2652 11 17C11 16.7348 11.1054 16.4804 11.2929 16.2929C11.4804 16.1054 11.7348 16 12 16C12.2652 16 12.5196 16.1054 12.7071 16.2929C12.8946 16.4804 13 16.7348 13 17ZM13 13C13 13.2652 12.8946 13.5196 12.7071 13.7071C12.5196 13.8946 12.2652 14 12 14C11.7348 14 11.4804 13.8946 11.2929 13.7071C11.1054 13.5196 11 13.2652 11 13C11 12.7348 11.1054 12.4804 11.2929 12.2929C11.4804 12.1054 11.7348 12 12 12C12.2652 12 12.5196 12.1054 12.7071 12.2929C12.8946 12.4804 13 12.7348 13 13ZM8 17C8 17.2652 7.89464 17.5196 7.70711 17.7071C7.51957 17.8946 7.26522 18 7 18C6.73478 18 6.48043 17.8946 6.29289 17.7071C6.10536 17.5196 6 17.2652 6 17C6 16.7348 6.10536 16.4804 6.29289 16.2929C6.48043 16.1054 6.73478 16 7 16C7.26522 16 7.51957 16.1054 7.70711 16.2929C7.89464 16.4804 8 16.7348 8 17ZM8 13C8 13.2652 7.89464 13.5196 7.70711 13.7071C7.51957 13.8946 7.26522 14 7 14C6.73478 14 6.48043 13.8946 6.29289 13.7071C6.10536 13.5196 6 13.2652 6 13C6 12.7348 6.10536 12.4804 6.29289 12.2929C6.48043 12.1054 6.73478 12 7 12C7.26522 12 7.51957 12.1054 7.70711 12.2929C7.89464 12.4804 8 12.7348 8 13Z" fill="#CBCAD5" />
                </svg>
                <input v-model="note.date" v-maska="masks.date" class="field__input" placeholder="04.04.2004">
              </label>
            </div>
            <div class="field">
              <p class="field__title">Время</p>
              <label class="field-content">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM12 6C12.2449 6.00003 12.4813 6.08996 12.6644 6.25272C12.8474 6.41547 12.9643 6.63975 12.993 6.883L13 7V11.586L15.707 14.293C15.8863 14.473 15.9905 14.7144 15.9982 14.9684C16.006 15.2223 15.9168 15.4697 15.7488 15.6603C15.5807 15.8508 15.3464 15.9703 15.0935 15.9944C14.8406 16.0185 14.588 15.9454 14.387 15.79L14.293 15.707L11.293 12.707C11.1376 12.5514 11.0378 12.349 11.009 12.131L11 12V7C11 6.73478 11.1054 6.48043 11.2929 6.29289C11.4804 6.10536 11.7348 6 12 6Z" fill="#CBCAD5" />
                </svg>
                <input v-model="note.time" v-maska="masks.time" class="field__input" placeholder="12:00">
              </label>
            </div>
          </div>
          <div class="grid-2">
            <div class="field">
              <div class="field-title">Вес</div>
              <label class="field-content">
                <input v-model.number="note.weight" v-maska="masks.weight" class="field__input" placeholder="Кг">
              </label>
            </div>
            <div class="field">
              <div class="field-title">Ваше артериальное давление</div>
              <label class="field-content">
                <input v-model.number="note.pressure" v-maska="masks.pressure" class="field__input" placeholder="Мм. рт. ст.">
              </label>
            </div>
          </div>
          <div class="grid-2">
            <button class="button" :disabled="sendDisabled || sending" @click="createNote">
              Добавить заметку
            </button>
            <button class="button button--gray" :disabled="sending" @click="resetNote">
              Отменить
            </button>
          </div>
        </div>
      </div>
    </main>
    <PersonalProfile />
  </div>
</template>

<script>
import { vMaska } from "maska/vue";
import PersonalHeader from "../../components/personal_area/PersonalHeader.vue";
import PersonalProfile from "../../components/personal_area/PersonalProfile.vue";
import PersoneInCaption from "../../components/personal_area/PersoneInCaption.vue";

export default {
  components: {
    PersonalHeader,
    PersonalProfile,
    PersoneInCaption,
  },
  name: "DiaryPage",
  data: () => ({
    note: {
      title: '',
      description: '',
      date: '',
      time: '',
      pressure: '',
      weight: '',
    },
    sending: false,
  }),
  directives: {
    maska: vMaska,
  },
  computed: {
    sendDisabled() {
      // eslint-disable-next-line no-unused-vars
      const { pressure, weight, ...required } = this.note;
      return Object.values(required).some(item => !String(item).length);
    },
    masks() {
      return {
        date: '##.##.####',
        time: '##:##',
        weight: "###",
        pressure: "###"
      }
    }
  },
  methods: {
    resetNote() {
      this.note = {
          title: '',
          description: '',
          date: '',
          time: '',
        };
    },
    async createNote() {
      try {
        this.sending = true;
        await this.$store.dispatch("createNote", this.note);
        this.resetNote();
      } finally {
        this.sending = false;
      }
    }
  },
};
</script>

<style scoped>
.body {
  display: flex;
}

.main {
  margin: 0 60px 56px 40px;
  width: 100%;
}

.content-element-caption__more::after {
  position: absolute;
  background: url(../../assets/img/list.svg);
  content: "";
  display: block;
  right: 0;
  top: -2px;
  width: 16px;
  height: 16px;
}

/* Caption */

.caption {
  padding: 40px 0px 0px 0px;
}

.caption-greetings__title {
  font-family: "PT";
  font-weight: 700;
  font-size: 48px;
  line-height: 1.2;
}
.head{
  margin-top: 25px;

}
.head__link{
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
font-size: 16px;
line-height: 140%;
color: rgba(0, 0, 0, 0.6);
}
/* filling */
.filling {
  max-width: 100%;
  width: 100%;
  align-items: flex-start;
    margin-top: 32px;
}

.content-element {
  max-width: 100%;
  width: 100%;
}

.note{
  border: 1px solid rgba(85, 85, 85, 0.2);
  border-radius: 10px;
  max-width: 854px;
  width: 100%;
  padding: 20px 20px 30px 20px;
  box-shadow: 0 40px 140px 0 rgba(0, 0, 0, 0.06);
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.field{
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 11px;
}
.field--textarea .field-content{
  height: unset;
  min-height: 160px;
  resize: vertical;
}
.field__title{
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  color: #100c40;
}
.field-content{
  display: flex;
  gap: 12px;
  align-items: center;
  height: 52px;
  padding: 14px 16px;
  border: 1px solid rgba(16, 12, 64, 0.2);
  border-radius: 10px;
  background: #fafafa;
  cursor: text;
}
.field-content svg{
  display: flex;
  flex-shrink: 0;
}
.field__input{
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;

}
.field__input::placeholder{
    color: rgba(16, 12, 64, 0.4);
}
.grid-2{
  display: grid;
  grid-template-columns: repeat(2,1fr);
  gap: 24px;
}
.button{
  background: #ff2031;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  color: #fff;
}
.button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
.button--gray{
  background: #a7a5b9;
  color: #fff;
}
@media (max-width: 1300px) {
  .main {
    margin-left: 20px;
  }

  /* Caption */
  .caption {
    padding: 40px 0px 30px 0px;
    justify-content: space-between;
  }

  .caption-greetings__title {
    font-size: 24px;
  }

}

@media (max-width: 950px) {
  .body {
    flex-direction: column;
  }

  .filling {
    flex-direction: column;
  }

  .caption {
    padding: 40px 0 0 0;
  }

  .caption-greetings {
    margin: 0 auto;
  }

  .caption-greetings__title {
    font-size: 32px;
  }

  .main {
    margin-left: 0;
    margin-right: 0;
    padding: 0 20px;
  }

  .profile {
    display: none;
  }

  /* additionall */
  .my-course-group {
    overflow-x: scroll;
  }

  .additionally-element {
    text-align: center;
  }

  .additionally {
    max-width: 100%;
  }

  .my-course-group {
    margin-top: 20px;
    flex-direction: row;
    overflow-x: visible;
    padding: 10px;
    position: relative;
  }

  .slider-last-block {
    display: block;
    position: absolute;
    width: 24px;
    height: 24px;
    left: -10px;
    bottom: 40%;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.09);
    border-radius: 100%;
    z-index: 2;
  }

  .my-course-group-wrapper {
    flex-direction: row;
    overflow-x: scroll;
  }

  .slider-next-block {
    display: block;
    position: absolute;
    width: 24px;
    height: 24px;
    right: -10px;
    bottom: 40%;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.09);
    border-radius: 100%;
    z-index: 2;
  }

  .slider-next-block img {
    width: 24px;
    height: 24px;
  }

  .slider-last-block img {
    width: 24px;
    height: 24px;
  }

  .separate-curse {
    max-width: 280px;
  }

  .filling-element {
    margin-bottom: 40px;
    margin-right: 0;
  }

  .content-filling {
    grid-template-columns: repeat(2, 1fr);
  }

  .slider-filling-element {
    margin: 0 auto 20px auto;
  }
}
@media (max-width: 786px) {
  .grid-2{
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}
@media (max-width: 600px) {
  .main {
    padding: 0 10px;
  }

  .carousel {
    display: flex;
    text-align: center;
    flex-direction: column;
    padding: 20px 20px 45px 20px;
  }

  .carousel * {
    margin: 0 auto;
  }

  .carousel-title {
    max-width: 267px;
    font-size: 32px;
  }

  .carousel-text {
    margin-top: 10px;
    max-width: 267px;
    font-size: 12px;
  }

  .carousel-button {
    margin-top: 199px;
    max-width: 223px;
  }

  .carousel-img {
    width: 298px;
    height: 282px;
    right: calc(50% - 149px);
  }

  .content {
    padding: 0 0 00px 0;
  }

  /*category*/
  .category-element {
    padding: 0;
    margin-top: 20px;
  }

  .category-element__caption {
    margin-bottom: 0;
  }

  /* description */
  .description {
    margin-top: 20px;
  }

  .description-nav {
    position: relative;
  }

  .description-nav-selected {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    background: #ffffff;
    border: 1px solid rgba(16, 12, 64, 0.2);
    border-radius: 10px;
    justify-content: space-between;
    width: 100%;
    box-shadow: 0px 40px 140px rgba(0, 0, 0, 0.06);
  }

  .description-nav-selected__text {
    font-family: "Gilroy";
    font-weight: 500;
    font-size: 14px;
    line-height: 1.6;
    color: rgba(16, 12, 64, 0.699999988079071);
  }

  .description-nav-filling {
    display: none;
    background: #fff;
    max-width: 100%;
    width: 100%;
    flex-direction: column;
    position: absolute;
    z-index: 2;
  }

  .description-nav__element {
    width: 100%;
    text-align: left;
    font-family: "Gilroy";
    font-weight: 500;
    font-size: 14px;
    line-height: 1.6;
    color: rgba(16, 12, 64, 0.699999988079071);
  }

  .description-nav__element-chozen {
    background: #fff;
    color: rgba(16, 12, 64, 0.699999988079071);
  }

  .description-nav__element:not(:last-child) {
    border-bottom: 1px solid rgba(16, 12, 64, 0.4);
    border-radius: 0 0 0 0;
  }

  .description-nav__element:first-child {
    border-radius: 10px 10px 0 0;
  }

  /*popular-course*/
  .content-element-caption__title {
    font-size: 20px;
    margin: 0 auto;
  }

  .content-element-caption__more {
    display: none;
  }

  .popular-course-filling {
    padding: 20px 0;
  }

  .tags {
    flex-wrap: nowrap;
    overflow-x: scroll;
    margin-top: 50px;
  }

  .content-filling {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    padding: 20px 0 0 0;
  }
}

input[type="time"]::-webkit-inner-spin-button,
input[type="time"]::-webkit-calendar-picker-indicator,
input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
}
</style>
